import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.css'],
})
export class ErrorModalComponent implements OnInit {
  @Output()
  closeModal = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  retry() {
    window.location.reload();
  }

  onClose() {
    this.closeModal.emit();
  }
}
